import styled from "styled-components";

const ReplacementsWrapper = styled.div`
  height: calc(100vh - 60px);
  width: 100%;
  .inner-txt {
    display: flex;
    height: calc(100vh - 116px);
    width: 100%;
    justify-content: center;
    align-items: center;
  }
`;

export default ReplacementsWrapper;
